export const ElementQuery = {
  all: '全て',
  exic: 'EX-ICのみ'
} as const;

export type ElementQueryKey = keyof typeof ElementQuery;

export const ElementQueryKeys: readonly ElementQueryKey[] = ['all', 'exic'];
